import { LegendConfigHelper } from './legend-config-helper';
import type { ChartContext } from '@src/slide/domain/ui-model/element-modeles/chart-models/context';
import type { ICommonConfig } from '@tencent/chart/lib/chart-ui/interface';
import type {
    IChartCommonConfigHelper,
    IChartConfigHelper,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/interface/chart-config.interface';
import { PlotAreaConfigHelper } from './plot-area-config-helper';

/**
 * 处理公用样式, 并将它们组合起来，比如legend，以后比如3D通用效果
 */
export class CommonCombineConfigHelper implements IChartCommonConfigHelper {
    private commonConfigHelpers: IChartCommonConfigHelper[];
    /**
     *
     * @param chartHelper chart配置处理类
     * @param context
     */
    public constructor(chartHelper: IChartConfigHelper, context: ChartContext) {
        // 添加要组合的common config解析类
        this.commonConfigHelpers = [];
        // TODO 补齐图例
        this.commonConfigHelpers.push(new LegendConfigHelper(chartHelper, context));
        this.commonConfigHelpers.push(new PlotAreaConfigHelper(chartHelper, context));
    }

    /**
     * 返回处理好的CommonConfig
     */
    public getCommonConfig(): ICommonConfig {
        return this.commonConfigHelpers.reduce((pre, cur) => {
            const commonConfig = cur.getCommonConfig();
            return { ...pre, ...commonConfig };
        }, {});
    }
}
